const openapi = {
	group: "block",
	attrs: {
		src: { default: null },
		flag: { default: true },
	},
};

export default openapi;
